export default __webpack_public_path__ + "static/media/home-travel-agency-slider-img02.170a1e34.jpg";